
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class GiftListClubModal extends Vue {
	@Prop() private clubDiscount: string;

	created() {
		console.log("$bus", this.$bus);
	}

	closeClubModal($event, isOutside) {
		if (isOutside && $event.target.closest(".epoq-club-modal")) {
			return;
		}
		console.log("closing club modal");
		this.$bus.$emit("epoqHideClubModal");
	}
}
